import styled from 'styled-components'
import { useWorld } from './use-world'
import { useEffect, useState } from 'react'

const Container = styled.div`
  position: absolute;
  bottom: 2rem;
  left: 2rem;
  right: 2rem;
  height: 10rem;
  background: #ffcc00;
  color: #335533;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Terminal = () => {
  const [text, setText] = useState()
  const { dialog, setDialog } = useWorld()

  const handler = () => {
    const d = [...dialog]
    d.shift()
    setDialog(d)
  }

  useEffect(() => {
    setText(dialog[0])
  }, [dialog])

  return (
    <>
      {dialog.length === 0
        ? null
        : (
        <Container onClick={handler}>{text}</Container>
          )}
    </>
  )
}
